import { formatEther } from "viem"

export function formatGachaEthAmount(wei: bigint) {
  const displayUnit = BigInt(10) ** BigInt(10)
  // Round up to eight ETH decimal places without understating the spending cap.
  const roundedWei =
    ((wei + displayUnit - BigInt(1)) / displayUnit) * displayUnit
  return formatEther(roundedWei)
}
